import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../../services/api';
import { Load } from '../../../components/Load';
import { Header } from '../../../components/Header';
import { Sidebar } from '../../../components/Sidebar';
import { Main } from '../../../components/Main';
import { Button, Col, Row, Form, Card, Table, InputGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';

import AlertMessage from '../../../components/Alert';
import { useParams } from 'react-router-dom';
import { Trash, Plus, X, ArrowLeft } from 'react-bootstrap-icons';
import Draggable from 'react-draggable';
import { Autocomplete, TextField, Box, Modal } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Viewer, Worker } from '@react-pdf-viewer/core'
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout'
import '@react-pdf-viewer/core/lib/styles/index.css'
import '@react-pdf-viewer/default-layout/lib/styles/index.css'
import InputMask from 'react-input-mask';
import { DateTime } from 'luxon';

interface PdfFile {
    key: string;
    name: string;
    data: string;
}
interface Exame {
    id?: number;
    id_exame?: number;
    nome?: string;
    data_realizacao?: string;
    valor_total?: string;
}


const EditarPcmsoAdm = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [exames, setExames] = useState<Exame[]>([]);
    const [showDraggable, setShowDraggable] = useState(false);
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const [trabalhador, setTrabalhador]: any = useState(null);
    const [examesBase, setExamesBase]: any = useState([]);
    const [reaproveitamentoPcmso, setReaproveitamentoPcmso]: any = useState([]);
    const [riscos, setRiscos]: any = useState([]);
    const [riscosBase, setRiscosBase]: any = useState([]);
    const [riscoSelecionado, setRiscoSelecionado]: any = useState();
    const [examesQuarentena, setExamesQuarentena]: any = useState([]);
    const [examesTabelaBalcao, setExamesTabelaBalcao]: any = useState([]);
    const [filter, setFilter] = useState('');
    const [funcoes, setFuncoes]: any = useState([]);
    const [funcoesSelecionadas, setFuncoesSelecionadas]: any = useState([]);
    const [novoExame, setNovoExame] = useState({ nome: '', valor_total: '', admissional: false, demissional: false, mudanca_risco: false, retorno: false });
    const [novoRisco, setNovoRisco] = useState({ nome: '', categoria: '' });
    const [mostrarNovoExame, setMostrarNovoExame] = useState(false);
    const [mostrarNovoRisco, setMostrarNovoRisco] = useState(false);
    const [exameSelecionado, setExameSelecionado]: any = useState();
    const [showHelpModal, setShowHelpModal] = useState(false);
    const [pdfFiles, setPdfFiles] = useState<PdfFile | null>(null);
    const [examesLoaded, setExamesLoaded] = useState(false);
    const [liberado, setLiberado] = useState(false);

    const navigate = useNavigate();
    const { idReapPcmso } = useParams()

    const newPlugin = defaultLayoutPlugin()
    
    const handleListExams = async (inputValue: any) => {
        if (inputValue.length >= 3) {
            const response = await api.get(`listar-base-exames/${inputValue}`);
            setExamesBase(response.data)
        } else {
            setExamesBase([])
        }
    }
    
    const handleAddExame = () => {
        setMostrarNovoExame(true);
    };
    
    const handleNovoExameChange = (field: string, value: string | boolean) => {
        setNovoExame({ ...novoExame, [field]: value });
    };
    
    const handleSubmit = async () => {
        try {
            const response = await api.put(`editar-reaproveitamento-pcmso/${reaproveitamentoPcmso.id}`, {
                exames: exames,
                riscos: riscos,
                funcoes: funcoes,
            });
            setAlert({
                show: true,
                message: 'PCMSO aprovado com sucesso.',
                variant: 'success'
            });
            setLiberado(true);
            navigate('/reaproveitamentos');
        } catch (error) {
            console.error('Erro ao aprovar PCMSO:', error);
            setAlert({
                show: true,
                message: 'Ocorreu um erro ao aprovar o PCMSO. Tente novamente.',
                variant: 'danger'
            });
        }
    };

    
    const handleSaveExame = async () => {
        try {
            // Verifica se o exame já foi adicionado antes
            const exameJaReaproveitado = exames.some(
                (exame: any) => exame.id_exame === exameSelecionado.id
            );
            
            if (exameJaReaproveitado) {
                setAlert({
                    show: true,
                    message: "Este exame já foi adicionado anteriormente.",
                    variant: "warning",
                });
                document.getElementById('exameSelecionado')?.focus();
                return;
            }
            
            // Verifica se um exame foi selecionado
            if (!exameSelecionado || !exameSelecionado.id) {
                setAlert({
                    show: true,
                    message: "Por favor, selecione um exame da lista.",
                    variant: "warning",
                });
                document.getElementById('exameSelecionado')?.focus();
                return;
            }
            
            // Verifica se o valor total foi preenchido
            if (!novoExame.valor_total) {
                setAlert({
                    show: true,
                    message: "O campo Valor Total é obrigatório e deve ser um número válido.",
                    variant: "danger",
                });
                document.getElementById('novoExame-valor_total')?.focus();
                return;
            }
            
            const valorTotalInt = Number(novoExame.valor_total.replace(',', '.').replace(/\./g, '')) || 0;
            
            const novoExameCompleto = {
                id_exame: exameSelecionado.id,
                nome_exame: exameSelecionado.nome,
                valor: valorTotalInt,
                admissional: novoExame.admissional,
                demissional: novoExame.demissional,
                mudanca_risco: novoExame.mudanca_risco,
                retorno: novoExame.retorno,
                id_reap_pcmso: reaproveitamentoPcmso.id, 
            }

            setExames((prevExames: Exame[]) => [...prevExames, novoExameCompleto]);
            
            console.log(exames)
            
            setExameSelecionado(null);
            setNovoExame({nome: "", valor_total: "", admissional: false, demissional: false, mudanca_risco: false, retorno: false});
            
            setAlert({
                show: true,
                message: "Exame adicionado com sucesso.",
                variant: "success",
            });
            
        } catch (error) {
            console.error("Erro ao adicionar exame:", error);
            setAlert({
                show: true,
                message: "Ocorreu um erro ao adicionar o exame. Tente novamente.",
                variant: "danger",
            });
        }
    };
    
    const handleRemoveExame = (id_exame: number) => {
        try {
            setExames((prevExames: Exame[]) => prevExames.filter((exame) => exame.id_exame !== id_exame));     
        } catch (error) {
            console.error("Erro ao remover exame:", error);
            setAlert({
                show: true,
                message: "Ocorreu um erro ao remover o exame. Tente novamente.",
                variant: "danger",
            });
        }
    };
    
    const handleSaveRisk = async () => {
        try {
            if (!riscoSelecionado.nome) {
                setAlert({
                    show: true,
                    message: "Por favor, preencha todos os campos para adicionar um risco.",
                    variant: "warning",
                });
                return;
            }

            const isRiscoIncluido = riscos.some((f: { id_risco: any }) => f.id_risco === riscoSelecionado.id);

            if (isRiscoIncluido) {
                setAlert({
                    show: true,
                    message: "Este risco já foi adicionado.",
                    variant: "warning",
                });
                return;
            }
            
            const novoRiscoCompleto = {
                id_risco: riscoSelecionado.id,
                id_reap_pcmso: reaproveitamentoPcmso.id,
                nome_categoria: riscoSelecionado.AteBaseRiscosCat.categoria,
                id_cat: riscoSelecionado.AteBaseRiscosCat.id,
                risco: riscoSelecionado.nome,
            }
            
            setRiscos((prevRiscos: any[]) => [...prevRiscos, novoRiscoCompleto]);
            setNovoRisco({ nome: '', categoria: '' });
            setAlert({
                show: true,
                message: "Risco adicionado com sucesso.",
                variant: "success",
            });
        } catch (error) {
            console.error("Erro ao adicionar risco:", error);
            setAlert({
                show: true,
                message: "Ocorreu um erro ao adicionar o risco. Tente novamente.",
                variant: "danger",
            });
        }
    };

    const handleRemoveRisk = (id_risco: number) => {
        try {
            setRiscos((prevRiscos: any[]) => prevRiscos.filter((risco) => risco.id_risco !== id_risco));
        } catch (error) {
            console.error("Erro ao remover risco:", error);
            setAlert({
                show: true,
                message: "Ocorreu um erro ao remover o risco. Tente novamente.",
                variant: "danger",
            });
        }
    };
    
    
    const handleShowDraggable = async () => {
        await loadTabelaBalcao();
        setShowDraggable(true);
    }

    const handleFilterChange = (event: any) => {
        setFilter(event.target.value.toLowerCase());
    };

    const filteredExames = examesTabelaBalcao.filter((exame: any) =>
        (exame.nome ? exame.nome.toLowerCase() : '').includes(filter)
    );

    // Remover uma função da lista de funções selecionadas
    const handleRemoveFuncao = (id_funcao: number) => {
        setFuncoes((prevFuncoes: any[]) =>
            prevFuncoes.filter((funcao) => funcao.id_funcao !== id_funcao)
        );
    };

    const handleListRisk = async (inputValue: any) => {
        if (inputValue.length > 1) {
            try {
                const encodedValue = encodeURIComponent(inputValue);
                const response = await api.get(`buscar-riscos/${encodedValue}`);
                setRiscosBase(response.data);
            } catch (error) {
                console.error('Erro ao buscar riscos', error);
                setAlert({ show: true, message: 'Erro ao buscar riscos. Tente novamente!', variant: 'danger' });
            } finally {
                setIsLoading(false);
            }
        } else {
            setRiscosBase([]);
        }
    };

    const clearExam = () => {
        setExameSelecionado('')
        novoExame.nome = '' 
        novoExame.valor_total = ''
    }
    
    const formatDate = (isoDate: any) => {
        const date = new Date(isoDate);
        
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Meses começam do 0
        const year = date.getUTCFullYear();
  
        return `${day}/${month}/${year}`;
    }
    
    
    
    const transformarPreco = (valor: any) => {
        const valorDividido = valor / 100;
        return valorDividido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };
    
    // const parseStringToNumber = (input: string): number => {
    //     const trimmedInput = input.trim();
        
    //     const cleanedInput = trimmedInput.replace(/[.,]/g, '');
        
    //     const result = parseFloat(cleanedInput);
        
    //     // Verifica se o resultado é um número válido
    //     if (isNaN(result)) {
    //         throw new Error('A string fornecida não pode ser convertida em um número.');
    //     }
        
    //     return result;
    // }
    
    const loadTabelaBalcao = async () => {
        try {
            const response = await api.get(`buscar-tabela-balcao`);
            setExamesTabelaBalcao(response.data);
        } catch (error) {
            console.error(error)
        }
    }

    const handleOpenPdf = () => {
        if (pdfFiles) {
            // Converte a string Base64 em um Blob
            const byteCharacters = atob(pdfFiles.data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);

            // Abre o PDF em uma nova aba
            window.open(url, '_blank');
        }
    };

    useEffect(() => {
        const fetchReapPcmso = async () => {
            try {
                const response = await api.get(`reaproveitamento-pcmso-id/${idReapPcmso}`);
                const responseData = response.data;
                setReaproveitamentoPcmso(responseData.reaproveitamentoPcmso);
                setExames(responseData.exames);
                setRiscos(responseData.riscos); 
                setFuncoes(responseData.funcoes);  
                setIsLoading(false); 

                if (responseData.reaproveitamentoPcmso.id_documento) {   
                    const responseDoc = await api.get(`get-file/${responseData.reaproveitamentoPcmso.id_documento}`);
                    const responseDocData = responseDoc.data;
                    setPdfFiles(responseDocData);
                }            
            } catch (error) {
                console.error('Erro ao buscar os Arquivos: ', error);
            }
        };
        
        fetchReapPcmso();
    
    }, [idReapPcmso]);
    
    return (
        <div>
        <Load isLoading={isLoading} />
        <Sidebar />
        <Header route='../../' />
        <Main>
            <Row>
                
                <Col md={12}>
                    <Card style={{
                        height: '500px',
                        border: '1px solid #0d6efd',
                        borderRadius: '8px',
                        margin: '10px',
                        width: '100%'
                    }}>
                        <Card.Body style={{
                            overflowY: 'auto',
                            maxHeight: '100%'
                        }}>
                             <Row className="mb-3">
                                <div style={{ display: 'flex', marginBottom: '6px' }}>
                                    <ArrowLeft
                                        size={24}
                                        color="#0d6efd"
                                        style={{ cursor: 'pointer', marginRight: '8px' }}
                                        onClick={() => navigate('/reaproveitamentos')}
                                    />
                                    <span
                                        style={{
                                            color: '#0d6efd',
                                            fontSize: '16px',
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => navigate('/reaproveitamentos')}
                                    >
                                        Voltar
                                    </span>
                                </div>
                                <hr />
                                <Col>
                                    <Card.Title>Detalhes do PCMSO</Card.Title>
                                    <div>
                                        <strong>Data de Realização:</strong> {reaproveitamentoPcmso.data_vigencia ? formatDate(reaproveitamentoPcmso.data_vigencia) : 'N/A'}
                                    </div>
                                    <div>
                                        <strong>GHE:</strong> {reaproveitamentoPcmso.nome_ghe || 'N/A'}
                                    </div>
                                    <div>
                                        <strong>Empresa:</strong> {reaproveitamentoPcmso.nome_empresa || 'N/A'}
                                    </div>
                                    <div>
                                        <strong>Médico Coordenador</strong> {reaproveitamentoPcmso.nome_medico || 'N/A'} | <strong>CRM:</strong> {reaproveitamentoPcmso.crm_medico || 'N/A'} | <strong>UF:</strong> {reaproveitamentoPcmso.uf_crm || 'N/A'}
                                    </div>
                                </Col>
                            </Row>
                            {pdfFiles && (
                                <Row className="mb-3">
                                    <Col>
                                        <Button 
                                            variant="primary" 
                                            onClick={handleOpenPdf}
                                        >
                                            Abrir PDF
                                        </Button>
                                    </Col>
                                </Row>
                            )}
                            <Row className="mb-3">
                                <Col>
                                    <Card.Title>Funções</Card.Title>
                                    {funcoes.map((funcao: any, index: number) => (
                                        <Row key={index} className="mb-1">
                                            <Col md={10}>
                                                <div className="exam-name" style={{ backgroundColor: '#e3e3e3', padding: '0.5rem', borderRadius: '4px' }}>
                                                    <div className="exam-name">
                                                        <div className="funcao-name">
                                                            {funcao.nome_funcao || ''}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                            {funcoes.length > 1 && !liberado && (
                                                <Col md={2} className="d-flex align-items-center justify-content-center">
                                                    <Button
                                                        variant="danger"
                                                        aria-label="Excluir função"
                                                        onClick={() => handleRemoveFuncao(funcao.id_funcao)}
                                                        size="sm"
                                                        style={{
                                                            padding: '0.2rem 0.4rem',
                                                            fontSize: '0.75rem'
                                                        }}
                                                    >
                                                        <Trash />
                                                    </Button>
                                                </Col>
                                            )}
                                        </Row>
                                    ))}
                                </Col>
                            </Row>
                            <hr />
                            <Row className="mb-3">
                                <Col>
                                    <Card.Title>Exames Incluídos</Card.Title>
                                </Col>
                                {!reaproveitamentoPcmso.liberado && (

                                    <Col className="text-end">
                                        <Button variant="primary"
                                        onClick={handleShowDraggable} 
                                        size="sm">
                                            Tabela Balcão
                                        </Button>
                                    </Col>
                                    )

                                }
                            </Row>
                            {!reaproveitamentoPcmso.liberado && (
                                <Row className="mb-2">
                                    <Col md={6}>
                                        <Button variant="success" size="sm" onClick={handleAddExame}>
                                            <Plus /> Novo exame
                                        </Button>
                                    </Col>
                                </Row>
                            )}

                            {mostrarNovoExame && (
                                <Row className="mb-1">
                                    <Col md={4}>
                                        <Form.Group controlId="formNovoExameNome">
                                            <Autocomplete
                                                options={examesBase}
                                                id="exameSelecionado"
                                                getOptionLabel={(option: any) => option ? option.nome : ""}
                                                value={exameSelecionado}
                                                onChange={(event: any, newValue: any) => {
                                                    setExameSelecionado(newValue);
                                                }}
                                                onInputChange={(event, inputValue) => {
                                                    handleListExams(inputValue);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        variant="outlined"
                                                        size="small"
                                                        style={{
                                                            padding: '0.2rem 0.4rem',
                                                            fontSize: '0.75rem'
                                                        }}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={2}>
                                        <Form.Group controlId="formNovoExameValor">
                                            <TextField
                                                type="text"
                                                id="novoExame-valor_total"
                                                placeholder="Valor"
                                                value={novoExame.valor_total}
                                                onChange={(e: any) => {
                                                    let valor = e.target.value.replace(/\D/g, '');
                                                    if (valor.length > 0) {
                                                        valor = (Number(valor) / 100).toFixed(2)
                                                            .replace('.', ',') 
                                                            .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                                    }
                                                    handleNovoExameChange('valor_total', valor);
                                                }}
                                                size="small"
                                                style={{
                                                    padding: '0.2rem 0.4rem',
                                                    fontSize: '0.75rem'
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={5} className="d-flex align-items-center flex-wrap">
                                        <div className="d-flex align-items-center mr-3" style={{ marginBottom: '0.2rem', marginRight:'8px' }}>
                                            <Form.Check.Input
                                                type="checkbox"
                                                checked={novoExame.admissional}
                                                onChange={(e) => handleNovoExameChange('admissional', e.target.checked)}
                                                style={{ marginRight: '0.25rem' }}
                                            />
                                            <Form.Check.Label style={{ marginBottom: '0', marginTop:'15px' }}>
                                                Admissional
                                            </Form.Check.Label>
                                        </div>

                                        <div className="d-flex align-items-center mr-3" style={{ marginBottom: '0.2rem', marginRight:'8px' }}>
                                            <Form.Check.Input
                                                type="checkbox"
                                                checked={novoExame.demissional}
                                                onChange={(e) => handleNovoExameChange('demissional', e.target.checked)}
                                                style={{ marginRight: '0.25rem' }}
                                            />
                                            <Form.Check.Label style={{ marginBottom: '0', marginTop:'15px' }}>
                                                Demissional
                                            </Form.Check.Label>
                                        </div>

                                        <div className="d-flex align-items-center mr-3" style={{ marginBottom: '0.2rem', marginRight:'8px' }}>
                                            <Form.Check.Input
                                                type="checkbox"
                                                checked={novoExame.mudanca_risco}
                                                onChange={(e) => handleNovoExameChange('mudanca_risco', e.target.checked)}
                                                style={{ marginRight: '0.25rem' }} 
                                            />
                                            <Form.Check.Label style={{ marginBottom: '0', marginTop:'15px' }}>
                                                Mudança de Risco
                                            </Form.Check.Label>
                                        </div>

                                        <div className="d-flex align-items-center" style={{ marginBottom: '0.2rem', marginRight:'8px' }}>
                                            <Form.Check.Input
                                                type="checkbox"
                                                checked={novoExame.retorno}
                                                onChange={(e) => handleNovoExameChange('retorno', e.target.checked)}
                                                style={{ marginRight: '0.25rem' }}
                                            />
                                            <Form.Check.Label style={{ marginBottom: '0', marginTop:'15px' }}>
                                                Retorno
                                            </Form.Check.Label>
                                        </div>
                                    </Col>

                                    <Col md={1} className="d-flex align-items-center justify-content-center">
                                        <Button
                                            variant="success"
                                            aria-label="Salvar exame"
                                            size="sm"
                                            onClick={handleSaveExame}
                                            style={{
                                                padding: '0.2rem 0.4rem',
                                                fontSize: '0.75rem',
                                                marginRight: '0.4rem'
                                            }}
                                        >
                                            Adicionar
                                        </Button>
                                    </Col>
                                </Row>
                            )}

                            <Row className="mb-2">
                                <Col md={6} className='col-padding-sides'>
                                    <Form.Label>Nome do Exame</Form.Label>
                                </Col>
                                
                                <Col md={3} className='col-padding-sides'>
                                    <Form.Label>Valor</Form.Label>
                                </Col>
                                <Col md={3} className='col-padding-sides'>
                                    <Form.Label>Detalhes Exame</Form.Label>
                                </Col>
                            </Row>

                            {exames.map((exame: any, index: any) => {
                                return (
                                    <Row key={exame.id} className="mb-1">
                                        <Col md={5} className='col-padding-sides'>
                                            <div className="exam-container">
                                                <div className="exam-content">
                                                    <div className="exam-name">
                                                        {exame.nome_exame || ''}
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        
                                        <Col md={2} className='col-padding-sides'>
                                            <Form.Group controlId={`formExameValor-${index}`}>
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id={`tooltip-exame-valor-${index}`}>
                                                            Valor referente à tabela balcão padrão
                                                        </Tooltip>
                                                    }
                                                >
                                                    <Form.Control
                                                        type="text"
                                                        name={`exameValor-${index}`}
                                                        value={transformarPreco(exame.valor) || ''}
                                                        disabled
                                                        size="sm"
                                                        style={{ fontSize: '0.8rem' }}
                                                    />
                                                </OverlayTrigger>
                                            </Form.Group>
                                        </Col>
                                        <Col md={4} className='col-padding-sides'>
                                            <div className="exam-container">
                                                <div className="exam-content">
                                                <div className="exam-name">
                                                    {(() => {
                                                        const examesSelecionados = [];

                                                        if (exame.admissional) {
                                                        examesSelecionados.push("Admissional");
                                                        }
                                                        if (exame.demissional) {
                                                        examesSelecionados.push("Demissional");
                                                        }
                                                        if (exame.mudanca_risco) {
                                                        examesSelecionados.push("Mudança de Risco");
                                                        }
                                                        if (exame.retorno) {
                                                        examesSelecionados.push("Retorno");
                                                        }

                                                        return examesSelecionados.length > 0 ? examesSelecionados.join(" | ") : null;
                                                    })()}
                                                </div>


                                                </div>
                                            </div>
                                        </Col>
                                        
                                        {!reaproveitamentoPcmso.liberado && (
                                            <Col md={1} className="d-flex align-items-center justify-content-center col-padding-sides">
                                                <Button
                                                    variant="danger"
                                                    aria-label="Excluir exame"
                                                    onClick={() => handleRemoveExame(exame.id_exame)}
                                                    size="sm"
                                                    style={{
                                                        padding: '0.2rem 0.4rem',
                                                        fontSize: '0.75rem'
                                                    }}
                                                >
                                                    <Trash />
                                                </Button>
                                            </Col>
                                        )}
                                    </Row>
                                );
                            })}

                            <hr />
                        </Card.Body>
                    </Card>
                    <Card style={{
                        height: '300px',
                        border: '1px solid #0d6efd',
                        borderRadius: '8px',
                        margin: '10px'
                    }}>
                        <Card.Body style={{ overflowY: 'auto' }}>
                            <Card.Title>Riscos Incluídos</Card.Title>
                            {!reaproveitamentoPcmso.liberado && (
                                <Row className="mb-2">
                                    <Col md={6}>
                                        <Button variant="success" size="sm" onClick={
                                            () => setMostrarNovoRisco(true)
                                        }>
                                            <Plus /> Novo risco
                                        </Button>
                                    </Col>
                                </Row>
                            )}

                            {mostrarNovoRisco && (
                                <Row className="mb-1">
                                    
                                    <Col md={4}>
                                        <Form.Group controlId="formDigiteSelecione" className="mb-2">
                                            <Form.Label style={{ fontSize: '0.85rem', paddingRight: '0.5rem' }}>Digite e Selecione:</Form.Label>
                                            <Autocomplete
                                                value={riscoSelecionado}
                                                onChange={(event, newValue) => {
                                                    if (event) {
                                                        event.preventDefault();
                                                    }
                                                    setRiscoSelecionado(newValue);
                                                }}
                                                onInputChange={(event, newInputValue) => {
                                                    if (event) {
                                                        event.preventDefault();
                                                    }
                                                    handleListRisk(newInputValue);
                                                }}
                                                noOptionsText="Digite e selecione"
                                                getOptionLabel={(option: any) => option ? option.nome : ""}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        variant="outlined"
                                                        label=""
                                                        size="small"
                                                        style={{
                                                            padding: '0.2rem 0.4rem',
                                                            fontSize: '0.75rem',
                                                            border: '1px solid #0d6efd',
                                                            borderRadius: '8px',
                                                            margin: 0,
                                                        }}
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            style: {
                                                                padding: '0.2rem 0.4rem',
                                                                fontSize: '0.75rem',
                                                            },
                                                        }}
                                                    />
                                                )}
                                                options={riscosBase}
                                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                            />
                                        </Form.Group>
                                    </Col>
                                
                                    <Col md={1} className="d-flex align-items-center justify-content-center">
                                        <Button
                                            variant="success"
                                            aria-label="Salvar exame"
                                            size="sm"
                                            onClick={handleSaveRisk}
                                            style={{
                                                padding: '0.2rem 0.4rem',
                                                fontSize: '0.75rem',
                                                marginRight: '0.4rem',
                                                marginTop: '0.8rem'
                                            }}
                                        >
                                            Adicionar
                                        </Button>
                                    </Col>
                                </Row>
                            )}
                            <Row className="mb-2 align-items-center">
                                <Col md={6} className='col-padding-sides'>
                                    <Form.Label>Categoria</Form.Label>
                                </Col>
                                <Col md={6} className='col-padding-sides'>
                                    <Form.Label>Risco</Form.Label>
                                </Col>
                            </Row>
                            {riscos.map((risco: any, index: any) => {
                                return (
                                    <Row key={index} className="mb-1">
                                        <Col md={6} className='col-padding-sides'>
                                            <div className="exam-container">
                                                <div className="exam-content">
                                                    <div className="exam-name">
                                                        {risco.nome_categoria || ''}
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={5} className='col-padding-sides'>
                                            <div className="exam-container">
                                                {risco.risco || ''}
                                            </div>
                                        </Col>
                                        {!reaproveitamentoPcmso.liberado && (
                                                <Col md={1} className="d-flex align-items-center justify-content-center col-padding-sides">
                                                    <Button
                                                        variant="danger"
                                                        aria-label="Excluir exame"
                                                        onClick={() => handleRemoveRisk(risco.id_risco)}
                                                        size="sm"
                                                        style={{
                                                            padding: '0.2rem 0.4rem',
                                                            fontSize: '0.75rem'
                                                        }}
                                                    >
                                                        <Trash />
                                                    </Button>
                                                </Col>
                                            )}
                                    </Row>
                                );
                            })}
                        
                            <Row>
                                
                            </Row>
                            {!reaproveitamentoPcmso.liberado && (
                                <Row className="mb-3">
                                    <Col md={12} className="d-flex justify-content-center">
                                        <Button
                                            variant="primary"
                                            size="sm"
                                            onClick={handleSubmit}
                                            style={{
                                                width: '40%',
                                                marginTop: '0.8rem'
                                            }}
                                        >
                                            Aprovar PCMSO
                                        </Button>
                                    </Col>
                                </Row>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Main>
        <AlertMessage
            show={alert.show}
            message={alert.message}
            variant={alert.variant}
            onClose={() => setAlert({ ...alert, show: false })}
        />
        <Modal
            open={showHelpModal}
            // onClose={handleCloseHelpModal}
            style={{ backdropFilter: 'blur(10px)' }}
        >
            <Box sx={{
                position: 'absolute',
                top: '40%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4,
                borderRadius: 2,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '400px',
                maxWidth: '90%',
                maxHeight: '80%'
            }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <h4>EXAME EM QUARENTENA</h4>
                    <br />
                    <p>
                        Exames marcados em vermelho são aqueles que não se encontram em nossa base.
                        <br />
                        As tratativas para estes casos são:
                    </p>
                    <p>
                        <strong>Primeiro caso</strong>: O exame em questão possui um nome diferente ao presente em nossa base.  Ex: o exame RAIO X está presente em nossa base como RX.
                        <br />
                        Este caso pode ser resolvido com a exclusão do exame em vermelho e a adição do presente em nossa base
                    </p>
                    <p>
                        <strong>Segundo caso: </strong> O exame em questão não existe. Neste caso, é necessária a exclusão do exame em vermelho.
                    </p>
                    <p>
                        <strong>Terceiro caso: </strong> O exame não existe em nossa base. Neste caso, é necessária a adição do exame em nosso sistema
                    </p>
                    <b>Link para cadastro do exame</b>
                    <a href='http://devweb.softwareatento.com.br/config/exames' target='_blank' rel="noopener noreferrer">Clique aqui</a>
                </Box>

            </Box>
        </Modal>
        {showDraggable && (
            <Draggable handle=".draggable-handle">
                <Card style={{
                    width: '30rem',
                    height: '50vh',
                    position: 'absolute',
                    top: '20%',
                    left: '30%',
                    zIndex: 9999
                }}>
                    <Card.Header className="draggable-handle" style={{
                        cursor: 'move',
                        position: 'relative',
                        paddingRight: '2.5rem'
                    }}>
                        Tabela Balcão
                        <X
                            onClick={() => setShowDraggable(false)}
                            style={{
                                position: 'absolute',
                                right: '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                cursor: 'pointer',
                                fontSize: '1.50rem',
                                color: 'gray'
                            }}
                        />
                    </Card.Header>
                    <Card.Body style={{
                        overflowY: 'auto',
                        maxHeight: 'calc(100% - 60px)'
                    }}>
                        <Form.Group className="mb-3">
                            <Form.Control
                                type="text"
                                placeholder="Buscar exame"
                                value={filter}
                                onChange={handleFilterChange}
                            />
                        </Form.Group>
                        <Table striped bordered hover size="sm" style={{ width: '100%' }}>
                            <thead>
                                <tr>
                                    <th style={{
                                        maxWidth: '65%',
                                        whiteSpace: 'normal',
                                        wordWrap: 'break-word'
                                    }}>Exame</th>
                                    <th style={{ whiteSpace: 'nowrap' }}>Valor</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredExames.map((exame: any, index: any) => (
                                    <tr key={index}>
                                        <td style={{
                                            maxWidth: '65%',
                                            whiteSpace: 'normal',
                                            wordWrap: 'break-word'
                                        }}>{exame.nome}</td>
                                        <td style={{
                                            whiteSpace: 'nowrap',
                                            textAlign: 'right'
                                        }}>{transformarPreco(exame.valor_venda)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </Draggable>
        )}
    </div>
    );
};

export default EditarPcmsoAdm;
